import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.5_next@14.2.15_react@18.3.1/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
